import React, { useState } from "react";
import "./Payment.css";

function Logs({ logs = [] }) {
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 10;

    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog);

    const totalPages = Math.ceil(logs.length / logsPerPage);

    return (
        <>
            <h1 className="dashboard-heading">Logs</h1>

            <div className="payment-dashboard">
                <section className="payment-table-section">
                    <table className="payment-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>type</th>
                                <th>Logs</th>
                                <th>User</th>
                                <th>Log In Time</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentLogs.length > 0 ? (
                                currentLogs.map((log, index) => (
                                    <tr key={index}>
                                        <td>{indexOfFirstLog + index + 1}</td>
                                        <td>{log.date}</td>
                                        <td>{log.type}</td>
                                        <td>{log.title}</td>
                                        <td>{log.username}</td>
                                        <td>{log.LogInTime}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        No logs available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </section>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        >
                            ◀ Prev
                        </button>

                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={currentPage === i + 1 ? "active" : ""}
                                onClick={() => setCurrentPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        >
                            Next ▶
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}

export default Logs;
